import { render, staticRenderFns } from "./DialogSelectItem.vue?vue&type=template&id=c81d092a&scoped=true"
import script from "./DialogSelectItem.vue?vue&type=script&lang=js"
export * from "./DialogSelectItem.vue?vue&type=script&lang=js"
import style0 from "./DialogSelectItem.vue?vue&type=style&index=0&id=c81d092a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81d092a",
  null
  
)

export default component.exports